<div class="
    fusion-fullwidth
    fullwidth-box
    fusion-builder-row-1 fusion-parallax-none
    nonhundred-percent-fullwidth
    non-hundred-percent-height-scrolling
  " style="
    background-color: rgba(255, 255, 255, 0);
    background-image: url('/wp-content/uploads/2015/12/about-call-to-action-57862405-1024x630.jpg');
    background-position: center bottom;
    background-repeat: no-repeat;
    padding-top: 100px;
    padding-right: 30px;
    padding-bottom: 20px;
    padding-left: 30px;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
  ">
  <div class="fusion-builder-row fusion-row">
    <div class="
        fusion-layout-column
        fusion_builder_column
        fusion_builder_column_1_1
        fusion-builder-column-0
        fusion-one-full
        fusion-column-first
        fusion-column-last
        1_1
      " style="margin-top: 0px; margin-bottom: 0px">
      <div class="fusion-column-wrapper" style="
          padding: 0px 0px 0px 0px;
          background-position: left top;
          background-repeat: no-repeat;
          -webkit-background-size: cover;
          -moz-background-size: cover;
          -o-background-size: cover;
          background-size: cover;
        " data-bg-url="">
        <style type="text/css">
          @media only screen and (max-width: 800px) {
            .fusion-title.fusion-title-1 {
              margin-top: 10px !important;
              margin-bottom: 10px !important;
            }
          }
        </style>
        <div class="
            fusion-title
            title
            fusion-title-1
            fusion-sep-none
            fusion-title-text
            fusion-title-size-one
          " style="margin-top: 0px; margin-bottom: 10px">
          <h1 class="title-heading-left" style="margin: 0">
            <h1 style="text-align: center">
              <span style="color: #ffffff">PROFESSIONISTI</span>
            </h1>
          </h1>
        </div>
        <div class="fusion-clearfix"></div>
      </div>
    </div>
    <form [formGroup]="searchForm" id="search-appform">
      <style type="text/css">
        input::-webkit-input-placeholder {
          color: #333333;
          text-align: left;
          font-weight: 300;
          font-family: Montserrat, Arial, Helvetica, sans-serif;
        }

        input:hover::-webkit-input-placeholder {
          color: #ffffff;
          transition: none;
        }

        /* Firefox < 19 */
        input:-moz-placeholder {
          color: #333333;
          text-align: left;
          font-weight: 300;
          font-family: Montserrat, Arial, Helvetica, sans-serif;
        }

        input:hover:-moz-placeholder {
          color: #ffffff;
          transition: none;
        }

        /* Firefox > 19 */
        input::-moz-placeholder {
          color: #333333;
          text-align: left;
          font-weight: 300;
          font-family: Montserrat, Arial, Helvetica, sans-serif;
        }

        input:hover::-moz-placeholder {
          color: #ffffff;
          transition: none;
        }

        /* Internet Explorer 10 */
        input:-ms-input-placeholder {
          color: #333333;
          text-align: left;
          font-weight: 300;
          font-family: Montserrat, Arial, Helvetica, sans-serif;
        }

        input:hover:-ms-input-placeholder {
          color: #ffffff;
          transition: none;
        }
      </style>
      <div style="
          content: '';
          display: table;
          clear: both;
          width: 100%;
          padding-top: 15px;
        ">
        <div id="form_wrapper" style="display: flex; justify-content: space-around">
          <style type="text/css">
            @media only screen and (max-width: 800px) {
              #form_wrapper {
                flex-wrap: wrap;
              }
            }
          </style>

          <!-- RAGIONE SOCIALE -->
          <div class="
              fusion-layout-column
              fusion_builder_column
              fusion_builder_column_2_5
              fusion-builder-column-2
              fusion-two-fifth
              2_5
            " style="
              margin-top: 0px;
              margin-bottom: 0px;
              width: 40%;
              width: calc(50% - ((4% + 4%) * 0.4));
            ">
            <div class="fusion-column-wrapper" style="
                background-color: #ffffff;
                background-position: left top;
                background-repeat: no-repeat;
                -webkit-background-size: cover;
                -moz-background-size: cover;
                -o-background-size: cover;
                background-size: cover;
              " data-bg-url="">
              <ul class="fusion-checklist fusion-checklist-2"
                style="font-size: 16px; line-height: 27.2px; padding: 3px">
                <li class="fusion-li-item">
                  <span style="
                      height: 27.2px;
                      width: 27.2px;
                      margin-right: 11.2px;
                      margin-right: 10px;
                      padding-top: 5px;
                      padding-right: 0;
                      padding-left: 10px;
                    " class="icon-wrapper circle-no"><i class="fusion-li-icon fa-building fas" style="
                        color: #333333;
                        padding-top: 15px;
                        padding-left: 8px;
                      "></i></span>
                  <div class="fusion-li-item-content" style="margin-left: 45px">
                    <input style="
                        font-size: 16px !important;
                        font-weight: 300;
                        letter-spacing: 1px !important;
                        padding-bottom: 0 !important;
                        padding-left: 5px !important;
                      " class="ng-app-input" type="text" formControlName="professionalName"
                      placeholder="RAGIONE SOCIALE" />
                  </div>
                </li>
              </ul>
              <div class="fusion-clearfix"></div>
            </div>
          </div>
          <!-- LOCALITA' -->
          <div class="
              fusion-layout-column
              fusion_builder_column
              fusion_builder_column_2_5
              fusion-builder-column-2
              fusion-two-fifth
              2_5
            " style="
              margin-top: 0px;
              margin-bottom: 0px;
              width: 40%;
              width: calc(50% - ((4% + 4%) * 0.4));
            ">
            <div class="fusion-column-wrapper" style="
                background-color: #ffffff;
                background-position: left top;
                background-repeat: no-repeat;
                -webkit-background-size: cover;
                -moz-background-size: cover;
                -o-background-size: cover;
                background-size: cover;
              " data-bg-url="">
              <ul class="fusion-checklist fusion-checklist-2"
                style="font-size: 16px; line-height: 27.2px; padding: 3px">
                <li class="fusion-li-item">
                  <span style="
                      height: 27.2px;
                      width: 27.2px;
                      margin-right: 11.2px;
                      margin-right: 10px;
                      padding-top: 5px;
                      padding-right: 0;
                      padding-left: 10px;
                    " class="icon-wrapper circle-no"><i class="fusion-li-icon fa-map-marker-alt fas" style="
                        color: #333333;
                        padding-top: 15px;
                        padding-left: 8px;
                      "></i></span>
                  <div class="fusion-li-item-content" style="margin-left: 45px">
                    <input style="
                        font-size: 16px !important;
                        font-weight: 300;
                        letter-spacing: 1px !important;
                        padding-bottom: 0 !important;
                        padding-left: 5px !important;
                      " class="ng-app-input" type="text" formControlName="professionalLocation"
                      placeholder="LOCALITA&#8217; (Città, Provincia o Cap)" />
                  </div>
                </li>
              </ul>
              <div class="fusion-clearfix"></div>
            </div>
          </div>
        </div>
      </div>
      <!-- INDIRIZZO
          <div class="fusion-layout-column fusion_builder_column fusion_builder_column_2_5 fusion-builder-column-2 fusion-two-fifth 2_5"
              style='margin-top:0px;margin-bottom:0px;width:40%;width:calc(30.00% - ((4% + 4%) * 0.3333));'>
              <div class="fusion-column-wrapper"
                  style="background-color:#ffffff;background-position:left top;background-repeat:no-repeat;-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover;"
                  data-bg-url="">
                  <ul class="fusion-checklist fusion-checklist-2" style="font-size:16px;line-height:27.2px;padding: 3px;">
                      <li class="fusion-li-item"><span style="height:27.2px;width:27.2px;margin-right:11.2px; margin-right: 10px;padding-top: 5px;padding-right: 0;padding-left: 10px;"
                              class="icon-wrapper circle-no"><i class="fusion-li-icon fa-map-marker-alt fas"
                                  style="color:#333333;padding-top: 15px;padding-left: 8px;"></i></span>
                          <div class="fusion-li-item-content" style="margin-left:45px;">
                              <input style="font-size: 16px !important;font-weight: 300;letter-spacing: 1px !important;padding-bottom: 0 !important;padding-left: 5px !important;"
                                  class="ng-app-input" type="text" formControlName="professionalAddress" placeholder="INDIRIZZO">
                          </div>
                      </li>
                  </ul>
                  <div class="fusion-clearfix"></div>
              </div>
          </div> -->
      <div style="
          content: '';
          display: table;
          clear: both;
          width: 100%;
          padding-top: 15px;
        ">
        <div id="form_wrapper" style="display: flex; justify-content: space-around">
          <style type="text/css">
            @media only screen and (max-width: 800px) {
              #form_wrapper {
                flex-wrap: wrap;
              }
            }
          </style>
          <!-- DATORE DI LAVORO -->
          <div class="
              fusion-layout-column
              fusion_builder_column
              fusion_builder_column_2_5
              fusion-builder-column-2
              fusion-two-fifth
              2_5
            " style="
              margin-top: 0px;
              margin-bottom: 0px;
              width: 40%;
              width: calc(50% - ((4% + 4%) * 0.4));
            ">
            <div class="fusion-column-wrapper" style="
                background-color: #ffffff;
                background-position: left top;
                background-repeat: no-repeat;
                -webkit-background-size: cover;
                -moz-background-size: cover;
                -o-background-size: cover;
                background-size: cover;
              " data-bg-url="">
              <ul class="fusion-checklist fusion-checklist-2"
                style="font-size: 16px; line-height: 27.2px; padding: 3px">
                <li class="fusion-li-item">
                  <span style="
                      height: 27.2px;
                      width: 27.2px;
                      margin-right: 11.2px;
                      margin-right: 10px;
                      padding-top: 5px;
                      padding-right: 0;
                      padding-left: 10px;
                    " class="icon-wrapper circle-no"><i class="fusion-li-icon fa-user-circle fas" style="
                        color: #333333;
                        padding-top: 15px;
                        padding-left: 8px;
                      "></i></span>
                  <div class="fusion-li-item-content" style="margin-left: 45px">
                    <input style="
                        font-size: 16px !important;
                        font-weight: 300;
                        letter-spacing: 1px !important;
                        padding-bottom: 0 !important;
                        padding-left: 5px !important;
                      " class="ng-app-input" type="text" formControlName="employer" placeholder="DATORE DI LAVORO" />
                  </div>
                </li>
              </ul>
              <div class="fusion-clearfix"></div>
            </div>
          </div>
          <!-- TITOLO PROFESSIONALE -->
          <div class="
              fusion-layout-column
              fusion_builder_column
              fusion_builder_column_2_5
              fusion-builder-column-2
              fusion-two-fifth
              2_5
            " style="
              margin-top: 0px;
              margin-bottom: 0px;
              width: 40%;
              width: calc(50% - ((4% + 4%) * 0.4));
            ">
            <div class="fusion-column-wrapper" style="
                background-color: #ffffff;
                background-position: left top;
                background-repeat: no-repeat;
                -webkit-background-size: cover;
                -moz-background-size: cover;
                -o-background-size: cover;
                background-size: cover;
                padding-right: 10px;
              " data-bg-url="">
              <ul class="fusion-checklist fusion-checklist-2"
                style="font-size: 16px; line-height: 27.2px; padding: 3px">
                <li class="fusion-li-item">
                  <span style="
                      height: 27.2px;
                      width: 27.2px;
                      margin-right: 11.2px;
                      margin-right: 10px;
                      padding-top: 5px;
                      padding-right: 0;
                      padding-left: 10px;
                    " class="icon-wrapper circle-no"><i class="fusion-li-icon fa-server fas" style="
                        color: #333333;
                        padding-top: 15px;
                        padding-left: 8px;
                      "></i></span>
                  <div class="fusion-li-item-content" style="margin-left: 45px">
                    <select formControlName="professionalSectorCode" style="
                        -webkit-appearance: none;
                        -moz-appearance: none;
                        font-size: 16px !important;
                        font-weight: 300;
                        letter-spacing: 1px !important;
                        padding-bottom: 0 !important;
                        padding-left: 5px !important;
                        border: none;
                        width: 100%;
                      ">
                      <option [ngValue]="null">TITOLO PROFESSIONALE</option>
                      <option [ngValue]="sectorProfesional.code"
                        *ngFor="let sectorProfesional of sectorProfessionalList">
                        {{ sectorProfesional.description }}
                      </option>
                    </select>
                  </div>
                </li>
              </ul>
              <div class="fusion-clearfix"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_1_1
          fusion-builder-column-8
          fusion-one-full
          fusion-column-first
          fusion-column-last
          1_1
        " style="margin-top: 0px; margin-bottom: 0px">
        <div class="fusion-column-wrapper" style="
            padding: 30px 0px 0px;
            background-position: left top;
            background-repeat: no-repeat;
            background-size: cover;
            height: auto;
          " data-bg-url="">
          <div class="fusion-sep-clear"></div>
          <div class="fusion-separator fusion-full-width-sep sep-none"
            style="margin-left: auto; margin-right: auto; margin-top: 20px"></div>
          <div class="fusion-button-wrapper fusion-aligncenter">
            <style type="text/css">
              .fusion-button.button-1 {
                border-radius: 0px;
              }
            </style>
            <a (click)="searchCompanies()" class="
                fusion-button
                button-flat button-xlarge button-default button-1
                fusion-button-default-span fusion-button-default-type
              " target="_self"><span class="fusion-button-text">CERCA</span></a>
          </div>
          <div class="fusion-sep-clear"></div>
          <div class="fusion-separator fusion-full-width-sep sep-none"
            style="margin-left: auto; margin-right: auto; margin-top: 50px"></div>
          <div class="fusion-clearfix"></div>
        </div>
      </div>
    </form>
  </div>
</div>
<div class="
    fusion-layout-column
    fusion_builder_column
    fusion_builder_column_1_1
    fusion-builder-column-22
    fusion-one-full
    fusion-column-first
    fusion-column-last
    1_1
  " style="margin-top: 0px; margin-bottom: 0px">
  <div class="fusion-column-wrapper" style="
      padding: 0px;
      background-position: left top;
      background-repeat: no-repeat;
      background-size: cover;
      height: auto;
    " data-bg-url="">
    <div class="fusion-sep-clear"></div>
    <div class="fusion-separator fusion-full-width-sep sep-none"
      style="margin-left: auto; margin-right: auto; margin-top: 50px"></div>
    <div class="fusion-clearfix"></div>
  </div>
</div>
<!-- CARDS -->
<style type="text/css">
  .fusion-fullwidth.fusion-builder-row-1 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link),
  .fusion-fullwidth.fusion-builder-row-1 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):before,
  .fusion-fullwidth.fusion-builder-row-1 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):after {
    color: #ffa626;
  }

  .fusion-fullwidth.fusion-builder-row-1 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):hover,
  .fusion-fullwidth.fusion-builder-row-1 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):hover:before,
  .fusion-fullwidth.fusion-builder-row-1 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):hover:after {
    color: #ffa626;
  }

  .fusion-fullwidth.fusion-builder-row-1 .pagination a.inactive:hover,
  .fusion-fullwidth.fusion-builder-row-1 .fusion-filters .fusion-filter.fusion-active a {
    border-color: #ffa626;
  }

  .fusion-fullwidth.fusion-builder-row-1 .pagination .current {
    border-color: #ffa626;
    background-color: #ffa626;
  }

  .fusion-fullwidth.fusion-builder-row-1 .fusion-filters .fusion-filter.fusion-active a,
  .fusion-fullwidth.fusion-builder-row-1 .fusion-date-and-formats .fusion-format-box,
  .fusion-fullwidth.fusion-builder-row-1 .fusion-popover,
  .fusion-fullwidth.fusion-builder-row-1 .tooltip-shortcode {
    color: #ffa626;
  }

  #main .fusion-fullwidth.fusion-builder-row-1 .post .blog-shortcode-post-title a:hover {
    color: #ffa626;
  }
</style>
<div *ngIf="!publicProfessionalCards || publicProfessionalCards.length === 0"
  style="text-align: center; margin-top: 8vh; margin-bottom: 8vh">
  <p style="font-size: 2rem">
    <strong>Non ci sono professionisti da visualizzare</strong>
  </p>
</div>
<div *ngFor="let professionalCard of publicProfessionalCards">
  <div class="
      fusion-fullwidth
      fullwidth-box
      fusion-builder-row-2
      nonhundred-percent-fullwidth
      non-hundred-percent-height-scrolling
    " style="
      background-color: rgba(255, 255, 255, 0);
      background-position: center center;
      background-repeat: no-repeat;
      padding-top: 0px;
      padding-bottom: 0px;
      max-width: 1170px;
      margin: auto;
      box-shadow: 0 5px 25px -2px grey;
      border-radius: 0.45rem;
      margin-bottom: 70px;
    ">
    <div class="fusion-builder-row fusion-row">
      <div id="heading_card" style="
          background-color: #ffa526b0;
          height: auto;
          border-top-right-radius: 0.45rem;
          border-top-left-radius: 0.45rem;
          content: '';
          clear: both;
          display: table;
          width: 100%;
          display: flex;
          align-items: center;
        ">
        <style type="text/css">
          @media only screen and (max-width: 800px) {
            #heading_card {
              flex-wrap: wrap;
            }

            .rating {
              padding-bottom: 10px;
            }
          }
        </style>
        <div class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_3_4
            fusion-builder-column-10
            fusion-three-fourth
            fusion-column-first
            3_4
          " style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: 75%;
            height: inherit;
          ">
          <div class="fusion-column-wrapper" style="
              padding: 0px;
              background-position: left top;
              background-repeat: no-repeat;
              background-size: cover;
              height: auto;
              padding: 10px 0;
              min-height: 90px;
            " data-bg-url="">
            <div class="fusion-text">
              <h3 data-fontsize="28" data-lineheight="40.6px" class="fusion-responsive-typography-calculated"
                style="--fontSize: 28; line-height: 1.45; padding: 0 40px">
                <strong *ngIf="professionalCard.profile.companyName">{{
                  professionalCard.profile.companyName
                  }}</strong>
                <strong *ngIf="!professionalCard.profile.companyName">
                  <em>"Nome azienda"</em>
                </strong>
              </h3>
            </div>
            <div class="fusion-text" style="padding: 0 40px">
              <span *ngIf="professionalCard.profile.address">{{
                professionalCard.profile.address
                }}</span>
              <span *ngIf="!professionalCard.profile.address"><em>"indirizzo"</em></span>
              <span *ngIf="professionalCard.profile.addressNumber">, {{ professionalCard.profile.addressNumber }}</span>
              <span *ngIf="!professionalCard.profile.addressNumber">, <em>"n°"</em></span>
              <span *ngIf="professionalCard.profile.zipCode">
                – {{ professionalCard.profile.zipCode }}</span>
              <span *ngIf="!professionalCard.profile.zipCode">
                – <em>"CAP"</em></span>
              <span *ngIf="professionalCard.profile.city">
                – {{ professionalCard.profile.city }}</span>
              <span *ngIf="!professionalCard.profile.city">
                – <em>"città"</em></span>
              <span *ngIf="professionalCard.profile.provinceCode">
                ({{ professionalCard.profile.provinceCode }})
              </span>
              <span *ngIf="!professionalCard.profile.provinceCode">
                <em> (provincia)</em>
              </span>
            </div>
            <div class="fusion-clearfix"></div>
          </div>
        </div>
      </div>
      <div id="card_details" style="
          content: '';
          clear: both;
          display: table;
          width: 100%;
          padding: 15px 20px;
        ">
        <div class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_3
            fusion-builder-column-12
            fusion-one-third
            fusion-column-first
            1_3
          " style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: calc(33.33% - ((4% + 6% + 4%) * 0.3333));
            margin-left: 2%;
            margin-right: 2%;
          ">
          <div class="fusion-column-wrapper" style="
              padding: 20px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              background-size: cover;
              height: auto;
            " data-bg-url="">
            <span class="
                logo
                fusion-imageframe
                imageframe-none imageframe-1
                hover-type-none
              " style="display: block; margin: auto"><img *ngIf="!professionalCard.profile.logo; else logo"
                loading="lazy" src="/wp-content/uploads/2020/02/Skimming-retina-logo-desktop.png" width="186" alt=""
                title="Skimming retina logo desktop" class="img-responsive wp-image-1190"
                style="display: block; margin: auto" />
              <ng-template #logo>
                <img loading="lazy" src="{{ professionalCard.profile.logo.documentUrl }}" width="186" alt=""
                  title="Skimming retina logo desktop" class="img-responsive wp-image-1190"
                  style="display: block; margin: auto" />
              </ng-template>
            </span>
            <div class="fusion-sep-clear"></div>
            <div class="fusion-separator fusion-full-width-sep sep-none"
              style="margin-left: auto; margin-right: auto; margin-top: 20px"></div>
            <div class="fusion-sep-clear"></div>
            <div class="fusion-separator fusion-full-width-sep sep-none"
              style="margin-left: auto; margin-right: auto; margin-top: 20px"></div>
            <div class="fusion-text">
              <p>
                <strong>GARE CREATE:</strong>
                {{ professionalCard.profile.stats.myTenders.total }}
              </p>
            </div>
            <div class="fusion-sep-clear"></div>
            <!-- <div class="fusion-text">
              <p>
                <strong>DATA ULTIMA CREAZIONE:</strong>
                {{
                  professionalCard.lastParticipationDate != null &&
                  professionalCard.lastParticipationDate != undefined
                    ? professionalCard.lastParticipationDate
                    : "Nessuna Informazione"
                }}
              </p>
            </div> -->
            <div class="fusion-clearfix"></div>
          </div>
        </div>
        <div class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_3
            fusion-builder-column-13
            fusion-one-third
            1_3
          " style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: calc(33.33% - ((4% + 6% + 4%) * 0.3333));
            margin-left: 3%;
            margin-right: 3%;
          ">
          <div class="fusion-column-wrapper" style="
              padding: 20px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              background-size: cover;
              height: auto;
              line-height: 0.9;
            " data-bg-url="">
            <div class="fusion-text">
              <p><strong>TIPO SOCIETÀ:</strong></p>
            </div>
            <div class="fusion-text">
              <p *ngIf="professionalCard.profile.typeCode">
                {{ getSocietyType(professionalCard.profile.typeCode) }}
              </p>
              <p *ngIf="!professionalCard.profile.typeCode">
                <em>nessuna informazione</em>
              </p>
            </div>
            <br />
            <br />
            <div class="fusion-text">
              <p><strong>TITOLO PROFESSIONALE:</strong></p>
            </div>
            <div class="fusion-text">
              <p *ngIf="professionalCard.profile.sectorCode">
                {{ getSectorType(professionalCard.profile.sectorCode) }}
              </p>
              <p *ngIf="!professionalCard.profile.sectorCode">
                <em>nessuna informazione</em>
              </p>
            </div>
            <br />
            <br />
            <div class="fusion-text">
              <p><strong>DATORE DI LAVORO:</strong></p>
            </div>
            <div class="fusion-text">
              <p *ngIf="professionalCard.profile.employer">
                {{ professionalCard.profile.employer }}
              </p>
              <p *ngIf="!professionalCard.profile.employer">
                <em>nessuna informazione</em>
              </p>
            </div>
            <br />
            <br />
            <div class="fusion-text">
              <p><strong>DIPENDENTI<br />(compreso il titolare):</strong></p>
            </div>
            <div class="fusion-text">
              <p *ngIf="professionalCard.profile.companySizeCode">
                {{ getCompanySize(professionalCard.profile.companySizeCode) }}
              </p>
              <p *ngIf="!professionalCard.profile.companySizeCode">
                <em>nessuna informazione</em>
              </p>
            </div>
            <br />
            <br />
            <div class="fusion-text">
              <p><strong>REFERENZE:</strong></p>
            </div>
            <div *ngIf="professionalCard.profile.references.length">
              <div *ngFor="
                  let refer of professionalCard.profile.references;
                  let i = index
                " class="fusion-text">
                <p>{{ refer.name }}</p>
              </div>
            </div>
            <div *ngIf="!professionalCard.profile.references.length">
              <div class="fusion-text">
                <p><em>nessuna referenza</em></p>
              </div>
            </div>
            <div class="fusion-clearfix"></div>
          </div>
        </div>
        <div class="
            fusion-layout-column
            fusion_builder_column
            fusion_builder_column_1_3
            fusion-builder-column-14
            fusion-one-third
            fusion-column-last
            1_3
          " style="
            margin-top: 0px;
            margin-bottom: 0px;
            width: calc(33.33% - ((4% + 6% + 4%) * 0.3333));
            margin-left: 2%;
            margin-right: 2%;
          ">
          <div class="fusion-column-wrapper" style="
              padding: 20px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              background-size: cover;
              height: auto;
              line-height: 0.9;
            " data-bg-url="">
            <div class="fusion-text">
              <p><strong>SPECIALIZZAZIONI:</strong></p>
            </div>
            <div *ngIf="professionalCard.profile.specializations.length">
              <div *ngFor="
                  let spec of professionalCard.profile.specializations;
                  let i = index
                " class="fusion-text">
                <p>{{ GetSpecializationDescription(spec.code) }}</p>
              </div>
            </div>
            <div *ngIf="!professionalCard.profile.specializations.length">
              <div class="fusion-text">
                <p><em>nessuna specializzazione</em></p>
              </div>
            </div>
            <br />
            <br />
            <div class="fusion-text">
              <p><strong>CERTIFICAZIONI:</strong></p>
            </div>
            <div *ngIf="professionalCard.profile.certifications.length">
              <div *ngFor="
                  let certif of professionalCard.profile.certifications;
                  let i = index
                " class="fusion-text">
                <p>{{ certif.name }}</p>
              </div>
            </div>
            <div *ngIf="!professionalCard.profile.certifications.length">
              <div class="fusion-text">
                <p><em>nessuna certificazione</em></p>
              </div>
            </div>
            <br />
            <br />
            <div class="fusion-text">
              <p><strong>ATTESTATI:</strong></p>
            </div>
            <div *ngIf="professionalCard.profile.certificates.length">
              <div *ngFor="
                  let certificate of professionalCard.profile.certificates;
                  let i = index
                " class="fusion-text">
                <p>{{ certificate.name }}</p>
              </div>
            </div>
            <div *ngIf="!professionalCard.profile.certificates.length">
              <div class="fusion-text">
                <p><em>nessun attestato</em></p>
              </div>
            </div>
            <div class="fusion-clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="
    fusion-layout-column
    fusion_builder_column
    fusion_builder_column_1_1
    fusion-builder-column-22
    fusion-one-full
    fusion-column-first
    fusion-column-last
    1_1
  " style="margin-top: 0px; margin-bottom: 0px">
  <div class="fusion-column-wrapper" style="
      padding: 0px;
      background-position: left top;
      background-repeat: no-repeat;
      background-size: cover;
      height: auto;
    " data-bg-url="">
    <div class="fusion-sep-clear"></div>
    <div class="fusion-separator fusion-full-width-sep sep-none"
      style="margin-left: auto; margin-right: auto; margin-top: 50px"></div>
    <div class="fusion-clearfix"></div>
  </div>
</div>
<!-- /CARDS -->
<style type="text/css">
  .fusion-fullwidth.fusion-builder-row-3 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link),
  .fusion-fullwidth.fusion-builder-row-3 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):before,
  .fusion-fullwidth.fusion-builder-row-3 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):after {
    color: #ffa626;
  }

  .fusion-fullwidth.fusion-builder-row-3 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):hover,
  .fusion-fullwidth.fusion-builder-row-3 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):hover:before,
  .fusion-fullwidth.fusion-builder-row-3 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):hover:after {
    color: #ffa626;
  }

  .fusion-fullwidth.fusion-builder-row-3 .pagination a.inactive:hover,
  .fusion-fullwidth.fusion-builder-row-3 .fusion-filters .fusion-filter.fusion-active a {
    border-color: #ffa626;
  }

  .fusion-fullwidth.fusion-builder-row-3 .pagination .current {
    border-color: #ffa626;
    background-color: #ffa626;
  }

  .fusion-fullwidth.fusion-builder-row-3 .fusion-filters .fusion-filter.fusion-active a,
  .fusion-fullwidth.fusion-builder-row-3 .fusion-date-and-formats .fusion-format-box,
  .fusion-fullwidth.fusion-builder-row-3 .fusion-popover,
  .fusion-fullwidth.fusion-builder-row-3 .tooltip-shortcode {
    color: #ffa626;
  }

  #main .fusion-fullwidth.fusion-builder-row-3 .post .blog-shortcode-post-title a:hover {
    color: #ffa626;
  }
</style>
<div class="
    fusion-fullwidth
    fullwidth-box
    fusion-builder-row-4
    nonhundred-percent-fullwidth
    non-hundred-percent-height-scrolling
  " style="
    background-color: rgba(255, 255, 255, 0);
    background-position: center center;
    background-repeat: no-repeat;
    padding-top: 0px;
    padding-right: 30px;
    padding-bottom: 0px;
    padding-left: 30px;
  ">
  <div class="fusion-builder-row fusion-row" *ngIf="showMoreProfesionals">
    <div class="
        fusion-layout-column
        fusion_builder_column
        fusion_builder_column_1_1
        fusion-builder-column-23
        fusion-one-full
        fusion-column-first
        fusion-column-last
        1_1
      " style="margin-top: 0px; margin-bottom: 0px">
      <div class="fusion-column-wrapper" style="
          padding: 0px;
          background-position: left top;
          background-repeat: no-repeat;
          background-size: cover;
          height: auto;
        " data-bg-url="">
        <div class="fusion-sep-clear"></div>
        <div class="fusion-separator fusion-full-width-sep sep-none"
          style="margin-left: auto; margin-right: auto; margin-top: 50px"></div>
        <div class="fusion-button-wrapper fusion-aligncenter">
          <style type="text/css">
            .fusion-button.button-2 {
              border-radius: 0px;
            }
          </style>
          <a class="
              fusion-button
              button-flat
              fusion-button-default-size
              button-default button-2
              fusion-button-default-span fusion-button-default-type
            " (click)="loadMoreCards()" target="_self"><span class="fusion-button-text">MOSTRA ALTRO</span></a>
        </div>
        <div class="fusion-sep-clear"></div>
        <div class="fusion-separator fusion-full-width-sep sep-none"
          style="margin-left: auto; margin-right: auto; margin-top: 50px"></div>
        <div class="fusion-clearfix"></div>
      </div>
    </div>
  </div>
</div>
<style type="text/css">
  .fusion-fullwidth.fusion-builder-row-4 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link),
  .fusion-fullwidth.fusion-builder-row-4 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):before,
  .fusion-fullwidth.fusion-builder-row-4 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):after {
    color: #ffa626;
  }

  .fusion-fullwidth.fusion-builder-row-4 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):hover,
  .fusion-fullwidth.fusion-builder-row-4 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):hover:before,
  .fusion-fullwidth.fusion-builder-row-4 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):hover:after {
    color: #ffa626;
  }

  .fusion-fullwidth.fusion-builder-row-4 .pagination a.inactive:hover,
  .fusion-fullwidth.fusion-builder-row-4 .fusion-filters .fusion-filter.fusion-active a {
    border-color: #ffa626;
  }

  .fusion-fullwidth.fusion-builder-row-4 .pagination .current {
    border-color: #ffa626;
    background-color: #ffa626;
  }

  .fusion-fullwidth.fusion-builder-row-4 .fusion-filters .fusion-filter.fusion-active a,
  .fusion-fullwidth.fusion-builder-row-4 .fusion-date-and-formats .fusion-format-box,
  .fusion-fullwidth.fusion-builder-row-4 .fusion-popover,
  .fusion-fullwidth.fusion-builder-row-4 .tooltip-shortcode {
    color: #ffa626;
  }

  #main .fusion-fullwidth.fusion-builder-row-4 .post .blog-shortcode-post-title a:hover {
    color: #ffa626;
  }
</style>
<!-- UNAUTHORIZED MODAL -->
<app-modal #unauthorizedModal>
  <ng-template #header>
    <div class="fusion-separator fusion-full-width-sep sep-none"
      style="margin-left: auto; margin-right: auto; margin-top: 100px"></div>
    <div class="fusion-text">
      <h3 style="text-align: center">ATTENZIONE</h3>
    </div>
  </ng-template>
  <ng-template #body>
    <div class="fusion-text">
      <h5>{{ "Per accedere a quest area è necessario compilare tutti i dati del profilo azienda all'interno dell'area
        riservata" | uppercase }}</h5>
    </div>
  </ng-template>
  <ng-template #footer>
    <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
      <div class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_1_2
          fusion-builder-nested-column-21
          fusion-one-fourth
          fusion-column-last
          1_2
        " style="
          margin-top: 0px;
          margin-bottom: 0px;
          width: 100%;
          width: calc(100% - ((1%) * 0.5));
        ">
        <div class="fusion-column-wrapper fusion-column-wrapper-22" style="
            padding: 0px 0px 0px 0px;
            background-position: left top;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
            margin-right: 4%;
          " data-bg-url="">
          <div class="fusion-button-wrapper fusion-align-block">
            <style type="text/css">
              .fusion-button.button-10 {
                border-radius: 0px;
              }
            </style>
            <a (click)="unauthorizedModalSubmit()" class="
                fusion-button
                button-flat
                fusion-button-default-size
                button-default button-10
                fusion-button-span-yes fusion-button-default-type
              " target="_self"><span class="fusion-button-text fusion-button-text-left">{{
                "APRI LA PAGINA DI PROFILO"
                }}</span></a>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</app-modal>